export default __webpack_public_path__ + "static/media/teamlayout-logo.12886a4a.svg";